/**
 * Header Dropdown Module
 * Handles Products dropdown toggle with keyboard accessibility
 */

export function initHeaderDropdown() {
  const triggers = document.querySelectorAll('[data-dropdown-toggle]');

  triggers.forEach(trigger => {
    const dropdownId = trigger.getAttribute('data-dropdown-toggle');
    const dropdown = document.querySelector(`[data-dropdown="${dropdownId}"]`);

    if (!dropdown) return;

    // Toggle on click
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns();
      if (!isExpanded) {
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    // Keyboard navigation within dropdown
    dropdown.addEventListener('keydown', (e) => {
      const links = dropdown.querySelectorAll('a');
      const currentIndex = Array.from(links).indexOf(document.activeElement);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextIndex = (currentIndex + 1) % links.length;
        links[nextIndex].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevIndex = currentIndex <= 0 ? links.length - 1 : currentIndex - 1;
        links[prevIndex].focus();
      }
    });
  });

  // Close on click outside
  document.addEventListener('click', (e) => {
    const isInsideDropdown = e.target.closest('[data-dropdown-toggle]') ||
                             e.target.closest('[data-dropdown]');
    if (!isInsideDropdown) {
      closeAllDropdowns();
    }
  });

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const activeDropdown = document.querySelector('[data-dropdown-toggle][aria-expanded="true"]');
      if (activeDropdown) {
        activeDropdown.setAttribute('aria-expanded', 'false');
        activeDropdown.focus();
      }
    }
  });

  function closeAllDropdowns() {
    triggers.forEach(t => {
      t.setAttribute('aria-expanded', 'false');
    });
  }
}
